var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58681 12.9465C9.60681 13.0532 9.5468 13.1665 9.4468 13.2065C8.69347 13.5065 7.86682 13.6665 7.01349 13.6665C5.54016 13.6665 4.18014 13.1932 3.08014 12.3798C2.98681 12.3132 2.96016 12.1798 3.02016 12.0798C3.38683 11.4265 4.82013 9.3265 7.9868 8.15317C8.1068 8.1065 8.24013 8.16649 8.28013 8.28649C9.07347 10.4132 9.44681 12.2132 9.58681 12.9465Z",
    fill: "#0057FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5469 8.25985C13.2402 9.89985 12.3202 11.3265 11.0335 12.2998C10.8935 12.4065 10.6935 12.3265 10.6602 12.1598C10.5202 11.4398 10.1802 9.8865 9.52683 8.03984C9.48016 7.89984 9.57352 7.7465 9.72019 7.7265C11.3802 7.5265 12.8335 7.8465 13.3802 7.99317C13.4935 8.03317 13.5668 8.14652 13.5469 8.25985Z",
    fill: "#0057FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3935 6.87984C12.7135 6.75984 10.9802 6.50649 9.20685 6.69982C9.10018 6.71316 9.00685 6.65316 8.96019 6.55316C8.93352 6.49316 8.91353 6.43316 8.88686 6.37316C8.78019 6.1265 8.66686 5.87317 8.55353 5.6265C8.49353 5.5065 8.55352 5.35983 8.67352 5.30649C10.5402 4.49983 11.5802 3.45983 11.9868 2.99316C12.0868 2.87983 12.2602 2.8865 12.3535 3.0065C13.1202 4.0265 13.5935 5.27316 13.6669 6.61983C13.6735 6.78649 13.5402 6.9065 13.3935 6.87984Z",
    fill: "#0057FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2935 2.19318C10.9468 2.61318 9.97351 3.61316 8.12684 4.3465C8.02018 4.39316 7.89351 4.34649 7.83351 4.23983C6.98017 2.69316 6.07349 1.39316 5.65349 0.806498C5.55349 0.666498 5.63352 0.466506 5.80018 0.43984C6.18685 0.373173 6.59351 0.339844 7.00685 0.339844C8.62018 0.339844 10.1069 0.913169 11.2602 1.87317C11.3602 1.9465 11.3735 2.09318 11.2935 2.19318Z",
    fill: "#0057FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34684 4.89317C3.82018 5.52651 1.58681 5.61318 0.77348 5.62651C0.620146 5.62651 0.506836 5.47984 0.546836 5.33317C1.02684 3.46651 2.30682 1.90651 3.99349 1.04651C4.09349 0.993179 4.22016 1.0265 4.28683 1.11984C4.63349 1.59984 5.57349 2.95318 6.49349 4.54651C6.56682 4.67985 6.50018 4.85317 6.34684 4.89317Z",
    fill: "#0057FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61348 6.73317C7.67348 6.85983 7.60017 7.01316 7.46684 7.05983C4.5135 8.01316 2.74683 10.3798 2.2135 11.1932C2.12683 11.3265 1.94017 11.3332 1.84017 11.2132C0.906836 10.0665 0.340169 8.75315 0.340169 7.15982V7.03983C0.340169 6.90649 0.446826 6.79982 0.58016 6.80649C1.42016 6.83982 4.16017 6.72648 7.00684 5.90648C7.1135 5.87315 7.23348 5.9265 7.28015 6.0265C7.39349 6.25983 7.50682 6.49317 7.61348 6.73317Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsIcon);
export default __webpack_public_path__ + "static/media/sports-icon.4726dfb5072b3a3298b8ea40c139a09a.svg";
export { ForwardRef as ReactComponent };